import { render, staticRenderFns } from "./PatentDrawing.vue?vue&type=template&id=6f449da7&scoped=true"
import script from "./PatentDrawing.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatentDrawing.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PatentDrawing.vue?vue&type=style&index=0&id=6f449da7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f449da7",
  null
  
)

export default component.exports